<input type="checkbox" #inputBox id="{{ id }}" [(ngModel)]="isChecked" [disabled]="isDisabled"
  (change)="changed.emit(inputBox?.checked)" />
<label class="toggle-button-switch" [ngClass]="{'multi-entity-edit': isToggleMultiEntity}"></label>
<label class="toggle-button-switch-click-handler" for="{{ id }}"></label>
<div class="toggle-button-text" [ngClass]="{'multi-entity-edit': isToggleMultiEntity}">
  <div class="toggle-button-text-on"></div>
  <div class="toggle-button-text-off"></div>
</div>